import React, { useCallback, useMemo } from "react";
import styles from "./Style.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useProductPetTable from "./ProductPetTable.hook";
import StatusPill from "../../../../../components/Status/StatusPill.component";
import classNames from "classnames";
import capitalizeFirstLetter from "../../../../../hooks/CommonFunction";

const ProductPetTable = ({renderPetList}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
  } = useProductPetTable({renderPetList});

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
        </div>
      </div>
    );
  }, []);
  const renderSecondCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        {user?.image ? (
          <img src={user?.image} alt="" crossOrigin="anonymous" />
        ) : (
          <span>N/A</span>
        )}
      </div>
    );
  }, []);
  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"INACTIVE"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "image",
        label: "Pet Image",
        sortable: false,
        render: (value, all) => <div>{renderSecondCell(all)}</div>,
      },

      {
        key: "name",
        label: "Pet Identifier",
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },

      {
        key: "",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all.status)}</div>,
      },
    ],
    [renderStatus,renderFirstCell,renderSecondCell]
  );

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default ProductPetTable;
